import { render, staticRenderFns } from "./exit-playback-recom-video.vue?vue&type=template&id=7267334a&scoped=true"
import script from "./exit-playback-recom-video.vue?vue&type=script&lang=js"
export * from "./exit-playback-recom-video.vue?vue&type=script&lang=js"
import style0 from "./exit-playback-recom-video.vue?vue&type=style&index=0&id=7267334a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267334a",
  null
  
)

export default component.exports